module.exports = __webpack_public_path__ + "static/media/Amelia60x120.3ddd9265.jpg";